<template>
    <c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <c-detail class="m-detail-form">
            <c-detail-item label="工单号">
                {{orderInfo.order_number}}
            </c-detail-item>
            <c-detail-item label="上门服务时间">
                {{orderInfo.process_start_date}} 至 {{orderInfo.process_end_date}}
            </c-detail-item>
            <c-detail-item label="是否使用机台">
                {{orderInfo.use_machine == 1 ? '是' : '否'}}
            </c-detail-item>
            <c-detail-item label="交通方式">
                <c-state dict="travelModeOptions" tag :value="orderInfo.travel_mode"></c-state>
            </c-detail-item>
            <c-detail-item label="实际成本总金额">
                ￥{{detailData.total_amount}}
            </c-detail-item>
            <c-detail-item label="车辆费用" v-if="carList && carList.length > 0">
                <c-table ref="carListTable" border :paging="false">
                    <c-table-column name="fee_type" label="费用支出项" width="50" summed>
                        <template #default="{data}">
                            <c-state dict="feeTypeActualDic" tag :value="data.fee_type"></c-state>
                        </template>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <!-- 定额标准、归属人员列先隐藏
                    <c-table-column name="unit_price" label="定额标准" width="50">
                        <template #default="{data}">
                            <span>{{data.unit_price>=0?data.unit_price.toFixed(2):'-'}}</span>
                            <span v-if="data.unit_price>=0">元/天</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="use_user_name" label="归属人员" width="50">
                        <template #default="{data}">
                            <span>{{data.use_user_name}}</span>
                        </template>
                    </c-table-column>
                    -->
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注" width="250">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="员工费用" v-if="userList && userList.length > 0">
                <c-table ref="userListTable" border :paging="false">
                    <c-table-column name="fee_type" label="费用支出项" width="50" summed>
                        <template #default="{data}">
                            <c-state dict="feeTypeActualDic" tag :value="data.fee_type"></c-state>
                        </template>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <!-- 定额标准、归属人员列先隐藏
                    <c-table-column name="unit_price" label="定额标准" width="50">
                        <template #default="{data}">
                            <span>{{data.unit_price>=0?data.unit_price.toFixed(2):'-'}}</span>
                            <span v-if="data.unit_price>=0">元/天</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="use_user_name" label="归属人员" width="50">
                        <template #default="{data}">
                            <span>{{data.use_user_name}}</span>
                        </template>
                    </c-table-column>
                    -->
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注" width="250">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="设备费用" v-if="equipmentList && equipmentList.length > 0">
                <c-table ref="equipmentListTable" border :paging="false">
                    <c-table-column name="fee_type" label="费用支出项" width="150" summed>
                        <template #default="{data}">
                            <c-state dict="feeTypeActualDic" tag :value="data.fee_type"></c-state>
                        </template>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注"  width="250">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="外协招工费用" v-if="outsourceList && outsourceList.length > 0">
                <c-table ref="outsourceListTable" border :paging="false">
                    <c-table-column name="fee_type" label="费用支出项" width="150" summed>
                        <template #default="{data}">
                            <c-state dict="feeTypeActualDic" tag :value="data.fee_type"></c-state>
                        </template>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注"  width="250">
                    </c-table-column>
                </c-table>
            </c-detail-item>
            <c-detail-item label="其他费用" v-if="otherList && otherList.length > 0">
                <c-table ref="otherListTable" border :paging="false">
                    <c-table-column name="fee_type" label="费用支出项" width="150" summed>
                        <template #default="{data}">
                            <c-state dict="feeTypeActualDic" tag :value="data.fee_type"></c-state>
                        </template>
                        <template #summed>
                            <span>合计：</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="amount" label="小计金额" width="50" :summed="({data}) => data.amount">
                        <template #default="{data}">
                            <span>{{data.amount.toFixed(2)}} 元</span>
                        </template>
                        <template #summed="{total}">
                            <span>{{total.toFixed(2)}} 元</span>
                        </template>
                    </c-table-column>
                    <c-table-column name="remark" label="备注"  width="250">
                    </c-table-column>
                </c-table>
            </c-detail-item>
        </c-detail>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'actualCostDetail',

    data() {
        return {
            detailData:{},
            orderInfo:{},
            carList:[],
            userList:[],
            equipmentList:[],
            outsourceList:[],
            otherList:[],
        }
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['feeTypeActualDic','travelModeOptions'])
    },
    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.detailData = data;
            this.orderInfo = this.detailData.order_info;
            if(this.detailData.actual_cost_det_list && this.detailData.actual_cost_det_list.length > 0){
                // 车辆折旧(fee_type=1)、人员成本(fee_type=4) 暂不展示
                this.carList = this.detailData.actual_cost_det_list.filter(item => item.fee_category == 1 && item.fee_type != 1);
                this.userList = this.detailData.actual_cost_det_list.filter(item => item.fee_category == 2 && item.fee_type != 4);
                this.equipmentList = this.detailData.actual_cost_det_list.filter(item => item.fee_category == 3);
                this.outsourceList = this.detailData.actual_cost_det_list.filter(item => item.fee_category == 4);
                this.otherList = this.detailData.actual_cost_det_list.filter(item => item.fee_category == 5);
            }
            this.$nextTick(() => {
                if (this.carList && this.carList.length > 0){
                    this.$refs.carListTable.setData(this.carList);
                }
                if (this.userList && this.userList.length > 0){
                    this.$refs.userListTable.setData(this.userList);
                }
                if (this.equipmentList && this.equipmentList.length > 0){
                    this.$refs.equipmentListTable.setData(this.equipmentList);
                }
                if (this.outsourceList && this.outsourceList.length > 0){
                    this.$refs.outsourceListTable.setData(this.outsourceList);
                }
                if (this.otherList && this.otherList.length > 0){
                    this.$refs.otherListTable.setData(this.otherList);
                }
            })
            //填充form表单
            this.$refs.dialog.open({
                title: '工单实际成本明细'
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>